module.exports = __webpack_public_path__ + "static/media/inlinefan.825ae45d.png";